


























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetExamPaperList, DelPaper } from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            paper_id: item.paper_id,
          },
        };
        DelPaper(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private edit(item: any) {
    this.$router.push({
      path: "/main/teacher/exam-paper-edit",
      query: {
        id: item.paper_id,
      },
    });
  }
  private goPreview(item: any) {
    this.$router.push({
      path: "/main/teacher/exam-paper-preview",
      query: {
        id: item.paper_id,
      },
    });
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("examPaperFilter", JSON.stringify(this.filters));
    GetExamPaperList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("examPaperFilter")) {
      this.filters = JSON.parse(localStorage.getItem("examPaperFilter") as any);
    }
    this.getList();
  }
}
